<template>
  <section
      class="slice slice-lg bg-cover bg-size--cover"
      :style="{'background-image': `url(${img})` }"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="card py-5 px-4 ">
            <div class="card-body">
              <slot name="pr-1"/>
              <slot name="pr-2"/>
              <slot name="pr-3"/>
            </div>
          </div>
        </div>


        <div class="col-lg-6">
          <div class="card bg-transparent s6-border-none  px-4 ">
            <div class="card-body s6-border-none">
              <slot name="pl-1"/>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "S6",
  props: {
    img: {
      default: "https://picsum.photos/1280/300",
    }
  },
};
</script>

<style scoped>
.bg-cover {
  background-position: center bottom;
}

.slice-lg {
  padding-top: 6rem;
  padding-bottom: 6rem;
}

.slice {
  position: relative;
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.bg-size--cover {
  background-size: cover;
}

.s6-border-none {
  border: none !important;
}

</style>